import { Component } from '@angular/core';
import { Environment } from 'src/environments/environment';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
})
export class FooterComponent {
	version = Environment.version;
	year = new Date().getFullYear();
}
